import { useQuery } from '@tanstack/react-query';
import { recipeAPI } from '@/utils/api';

/**
 * useRelatedRecipes — fetches related recipes using server-side country filter.
 * Returns 4–8 recipes, excluding the current recipe.
 */
export function useRelatedRecipes(recipe, lang = 'en') {
  const slug = recipe?.slug;
  const country = recipe?.origin_country || recipe?.country;

  return useQuery({
    queryKey: ['related-recipes', slug, lang],
    queryFn: async () => {
      // Fetch same-country recipes using server-side filter
      const res = await recipeAPI.getFeatured(9, lang, 0, country);
      const sameCountry = (res.data.recipes || []).filter(r => r.slug !== slug);
      return sameCountry.slice(0, 8);
    },
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });
}
